
/*========================================================================
 * $Id: toolbar.js 85482 2015-07-23 15:01:19Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

Mindbreeze.define('utils/aria/toolbar',["jquery", "underscore", "utils/keys"], function ($, _, keys) {

  return {
    update: function ($el, e) {
      var that = this,
          $entries = $el.find("a:visible, button:visible"),
          $target = $(e.target),
          $currentEl;

      this.$el = $el;

      $entries.each(function () {
          if (!$currentEl && (document.activeElement === this || $(document.activeElement).parentsUntil(this).parent()[0] === this)) {
            $currentEl = $(this);
          }
      });

      if (!$currentEl) {
        $currentEl = $el.find("[tabindex=0]");
      }

      if ($currentEl.length !== 1) {
        $currentEl = null;
      }

      $entries.each(function () {
          var $childEl = $(this);
          $currentEl = $currentEl || $childEl;

          if ($childEl !== $currentEl) {
            $childEl.attr("tabindex", "-1");
          }
      });

      if ($currentEl) {
        $currentEl.attr("tabindex", "0");
        if (!$currentEl.is(":focus") && e.target !== $currentEl[0]) {
          window.setTimeout(function () {
            $currentEl.focus();
          }, 0);
        }
      }

      $el.on("focus.mb-role-toolbar", function(e) {
        that.destroy();
        that.update($el, e);
        e.preventDefault();
        e.stopPropagation();
      });

      $el.on("keydown.mb-role-toolbar", function (e) {
          var call,
              $toolbar = $(e.currentTarget),
              $entries = $toolbar.find("a:visible, button:visible"),
              $toSelect

          if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) {
            return true;
          }

          switch (e.which) {
            // TODO: handle other keys as well?
           case keys.left: call = "prev"; break;
           case keys.up: call = "prev"; break;
           case keys.right: call = "next"; break;
           case keys.down: call = "next"; break;
           case keys.home: call = "first"; break;
           case keys.end: call = "last"; break;
           case keys.esc: 
           case keys.tab:
             if ($el.attr("role") === "menu") that.closeMenu($el); break;
          }

          if (call) {
            var index = $entries.index(e.target);
            if (index >= 0) {
              if (call === "first") {
                index = 0;
              } else if (call === "prev") {
                index = index - 1;
              } else if (call === "last") {
                index = $entries.length - 1;
              } else {
                index = index + 1;
              }

              if (index >= $entries.length) {
                index = 0;
              }
              if (index < 0) {
                index = $entries.length - 1;
              }

              $toSelect = $entries.eq(index);
            }
            if (!$toSelect) {
              $toSelect = $entries.eq(0);
            }

            if ($toSelect.length) {
              $entries.filter("[tabindex=0]").attr("tabindex", "-1");
              $toSelect.attr("tabindex", "0");
              $toSelect.focus();
            }

            e.preventDefault();
            e.stopPropagation();
          }

          return true;
      });
    },

    closeMenu: function ($el) {
      $el.trigger("menuclose");
    },

    destroy: function () {
      this.$el && this.$el.off(".mb-role-toolbar");
    }
  }
});
